import { observer } from 'mobx-react';
import { AlreadyTranslated, AlreadyTranslatedText } from '../../../../../../../../Translations';
import ManagedByExecOnline from '../../../../../LearningCollectionSteps/ManagedByExecOnline';
import { DraggableProvided } from '@hello-pangea/dnd';
import DragIndicatorIcon from '../../../../../../../Cutesies/DragIndicatorIcon';
import Accordion from '../../../../../../../Accordion';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import NoExperiencesIcon from '../NoExperiencesIcon';

interface Props {
  name: AlreadyTranslatedText;
  experienceCount: number;
  provided: DraggableProvided;
}

function ProductCollection({ name, experienceCount, provided }: Props) {
  return (
    <div ref={provided.innerRef} {...provided.draggableProps} className="border-b">
      <Accordion
        titleIcon={
          <div className="cursor-grab" {...provided.dragHandleProps}>
            <DragIndicatorIcon />
          </div>
        }
        titleJSX={
          <div className="text-sm font-semibold mr-2">
            <AlreadyTranslated content={name} />
          </div>
        }
        headerInfo={
          <div className="flex gap-1">
            <NoExperiencesIcon experienceCount={experienceCount} />
            <LockClosedIcon className="h-5" />
          </div>
        }
      >
        <div className="px-7 pb-7">
          <ManagedByExecOnline />
        </div>
      </Accordion>
    </div>
  );
}

export default observer(ProductCollection);
